import instance from './axiosInstance';
import type { AppInfo } from 'pages/admin/hooks';

export const getAppDetail = async <T = AppInfo>(clientId: string): Promise<T> => {
  const res = await instance.get<T>(`/apps/${clientId}`);
  return res.data;
};
